import styled from "styled-components";

interface StyledImageProps {
  width?: string;
  height?: string;
  margin?: string;
  padding?: string;
  backgroundColor?: string;
  border?: string;
  borderRadius?: string;
  pointerIsOpen?: boolean;
  tooltipInfo?: string;
  opacity?: number;
  rotate?: number;
}

// eslint-disable-next-line import/prefer-default-export
export const StyledImage = styled.img<StyledImageProps>`
  width: ${({ width = "auto" }) => width};
  height: ${({ height = "100%" }) => height};
  max-height: 100%;

  margin: ${({ margin = "0" }) => margin};
  padding: ${({ padding = "0" }) => padding};

  ${({ pointerIsOpen }) => pointerIsOpen && `cursor:pointer;`};
  ${({ border }) => border && `border :${border};`};
  ${({ borderRadius }) => borderRadius && `border-radius :${borderRadius};`};
  ${({ opacity }) => `opacity: ${opacity}`};
  ${({ backgroundColor }) => `background-color: ${backgroundColor}`};

  ${({ rotate }) => rotate && `transform: rotate(${rotate}deg)`};

  outline: none;
`;

export const StyledToolTipContainer = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;

  outline: none;

  user-select: none;

  &:hover {
    & > :nth-child(2) {
      visibility: visible;
      opacity: 1;
    }
  }
`;
